import {Component} from '@angular/core';

@Component({
  selector: 'mvw-loading-vacature-detail',
  templateUrl: './loading-vacature-detail.component.html'
})
export class LoadingVacatureDetailComponent {

}
